export enum MenuItems {
    //Setup
    Account = 'Account',
    Class = 'Class',
    Pricing = 'Pricing',

}

export enum Status {
    ACTIVE = 1,
    INACTIVE = 2
}

export enum Severity {
    Success = 'success',
    Error = 'error',
    Warn = 'warn'
}

export enum Answer {
    Yes = 'Yes',
    No = 'No'
}

export const ObjectNames = {
    BehaviorSubjectVariable: 'add',

    //Chart of Accounts
    AddAccountTitle: 'Add Account',
    EidtAccountTitle: 'Edit Account',
    EditAction: 'edit',
    AddAction: 'add',

    //Class
    AddClassTitle: 'Add Class',
    EidtClassTitle: 'Edit Cass',
    parentType: 'parent',
    childType: 'child',
    subChildType: 'subChild'
}

export enum FinanceObjectNames {
    CHART_OF_ACCOUNTS = "Chart of Accounts",
    Ledger = "Ledger",
    Journal = "Journal",
    GENERAL_LEDGER = "General Ledger",
    TTRIAL_BALANCE = "Trial Balance",
    BANK = "Bank",
    FINANCIAL_STATEMENTS = "Financial Statements",
    Pl = "P&L",
    BALANCE_SHEET = "Balance Sheet",
    EXPENSE = "Expense",
    CREDIT_CARD_RECOCILE = "Credit Card Reconcile",
    CREDIT_CARD = "Credit Card",
    CASHFLOW = "Cashflow",
    BANK_RECONCILE = "Bank Reconcile",
    Accounting_Periods = "Accounting Periods",
    Closing_Years = "Closing Years",
}
export const permissionMap = [
    { permissionVar: 'chartMenuPermission', objectName: FinanceObjectNames.CHART_OF_ACCOUNTS },
    { permissionVar: 'ledgerMenuPermission', objectName: FinanceObjectNames.Ledger },
    { permissionVar: 'journalMenuPermission', objectName: FinanceObjectNames.Journal },
    { permissionVar: 'glMenuPermission', objectName: FinanceObjectNames.GENERAL_LEDGER },
    { permissionVar: 'trialMenuPermission', objectName: FinanceObjectNames.TTRIAL_BALANCE },
    { permissionVar: 'bankMenuPermission', objectName: FinanceObjectNames.BANK },
    { permissionVar: 'statementMenuPermission', objectName: FinanceObjectNames.FINANCIAL_STATEMENTS },
    { permissionVar: 'plMenuPermission', objectName: FinanceObjectNames.Pl },
    { permissionVar: 'balanceMenuPermission', objectName: FinanceObjectNames.BALANCE_SHEET },
    { permissionVar: 'cashflowMenuPermission', objectName: FinanceObjectNames.CASHFLOW },
    { permissionVar: 'bankReconcileMenuPermission', objectName: FinanceObjectNames.BANK_RECONCILE },
    { permissionVar: 'expenseMenuPermission', objectName: FinanceObjectNames.EXPENSE },
    { permissionVar: 'creditcardMenuPermission', objectName: FinanceObjectNames.CREDIT_CARD },
    { permissionVar: 'ccReconcileMenuPermission', objectName: FinanceObjectNames.CREDIT_CARD_RECOCILE },
    { permissionVar: 'accountingPeriodsMenuPermission', objectName: FinanceObjectNames.Accounting_Periods },
    { permissionVar: 'closingYearsMenuPermission', objectName: FinanceObjectNames.Closing_Years },
];